import { Outlet } from "react-router-dom";

import { APIProvider } from "@vis.gl/react-google-maps";

export default function Layout() {
  return (
    <>
      <APIProvider
        apiKey={"AIzaSyAqk45RIVytV7tiTjTy2UISpHEgSWjl1vg"}
        onLoad={() => console.log("Maps API has loaded.")}
      >
        <Outlet />
      </APIProvider>
    </>
  );
}
